import React, { useState, useEffect } from "react";
import Axios from "axios";
import { useSelector } from "react-redux";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend,
  CartesianGrid, ResponsiveContainer,
  LabelList
} from "recharts";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";

export default function BaoCaoNhanSu() {
  const { user } = useSelector((state) => state.auth);
  const [chartData, setChartData] = useState([]);
  const [year, setYear] = useState("2025");

  const monthsOfYear = Array.from({ length: 12 }, (_, i) => {
    const month = (i + 1).toString().padStart(2, '0');
    return `${year}-${month}`;
  });

  const years = ["2023", "2024", "2025"];

  const processData = (rawData) => {
    const grouped = {};

    rawData.forEach(item => {
      const month = item.month_year;
      if (!grouped[month]) {
        grouped[month] = {
          month,
          ct: 0,
          tv: 0,
          cnv: 0,
          tts: 0,
          ctv: 0,
          nv: 0,
          total: 0,
          online:0
        };
      }

      grouped[month].ct += item.ct;
      grouped[month].tv += item.tv;
      grouped[month].cnv += item.cnv;
      grouped[month].tts += item.tts;
      grouped[month].ctv += item.ctv;
      grouped[month].nv += item.nv;
      grouped[month].total += item.total || 0;
      grouped[month].online += item.online || 0;
    });

    return Object.values(grouped);
  };

  const ensureAllMonthsPresent = (groupedData) => {
    const map = {};
    groupedData.forEach(item => map[item.month] = item);

    return monthsOfYear.map(month => {
      const item = map[month] || {
        month,
        ct: 0,
        tv: 0,
        cnv: 0,
        tts: 0,
        ctv: 0,
        nv: 0,
        total: 0,
        online:0
      };
      return {
        ...item,
        monthFormatted: `${month.split("-")[1]}/${month.split("-")[0]}` // => m/Y
      };
    });
  };

  const loadData = (selectedYear) => {
    Axios.get(`${URL_LIST_ALL}users_baocao?limit=10000000&timeyear=${selectedYear}`, user.config)
      .then(res => {
        if (res.data.status === "success") {
          const grouped = processData(res.data.data);
          const fullData = ensureAllMonthsPresent(grouped);
          setChartData(fullData);
        } else {
          console.log(res.data.message);
        }
      })
      .catch(console.log);
  };

  useEffect(() => {
    loadData(year);
  }, [year, user]);

  return (
    <AkkhorLayout idrole="bao-cao-nhan-su">
      <div className="breadcrumbs-area">
        <ul>
          <li><a href="/">Trang chủ</a></li>
          <li>Báo cáo nhân sự</li>
        </ul>
      </div>

      <div className="main-baocao w-100">
        <h4>Báo cáo nhân sự theo tháng (năm {year})</h4>

        <div style={{ marginBottom: 20 }}>
          <label>Chọn năm: </label>
          <select
            value={year}
            onChange={(e) => setYear(e.target.value)}
            style={{ marginLeft: 10, padding: "5px 10px" }}
          >
            {years.map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        </div>

        <ResponsiveContainer width="100%" height={500}>
          <BarChart
            data={chartData}
            margin={{ top: 50, right: 10, left: 10, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="monthFormatted" />
            <YAxis
              domain={[0, (dataMax) => Math.ceil(dataMax * 1.1)]}
              tickFormatter={(tick) => Number.isInteger(tick) ? tick : ''}
            />
            <Tooltip />
            <Legend />

            <Bar dataKey="total" name="Tổng số" fill="#90f"><LabelList dataKey="total"position="top"formatter={(value) => (value === 0 ? '' : value)}/></Bar>
            <Bar dataKey="online" name="Onboard" fill="#38761d"><LabelList dataKey="online"position="top"formatter={(value) => (value === 0 ? '' : value)}/></Bar>
            <Bar dataKey="ct" name="Chính thức" fill="#4caf50"><LabelList dataKey="ct"position="top"formatter={(value) => (value === 0 ? '' : value)}/></Bar>
            <Bar dataKey="tv" name="Thử việc" fill="#0000ff"><LabelList dataKey="tv"position="top"formatter={(value) => (value === 0 ? '' : value)}/></Bar>
            <Bar dataKey="cnv" name="Chưa nhận việc" fill="#4a86e8"><LabelList dataKey="cnv"position="top"formatter={(value) => (value === 0 ? '' : value)}/></Bar>
            <Bar dataKey="tts" name="Thực tập sinh" fill="#ff9800"><LabelList dataKey="tts"position="top"formatter={(value) => (value === 0 ? '' : value)}/></Bar>
            <Bar dataKey="ctv" name="CTV" fill="#ea9999"><LabelList dataKey="ctv"position="top"formatter={(value) => (value === 0 ? '' : value)}/></Bar>
            <Bar dataKey="nv" name="Nghỉ việc" fill="#f44336"><LabelList dataKey="nv"position="top"formatter={(value) => (value === 0 ? '' : value)}/></Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </AkkhorLayout>
  );
}
